import React, {FC, ReactNode} from 'react';

import {useEventHandler} from '../../../../../libs/shared/core/src/helpers/react/hooks/useEventHandler';
import {SandboxScenariosEnum} from '../../../../helpers/sandbox/sandboxScenarioHelpers';
import {InboxesFiltersEnum, InboxesSearchLocationsEnum} from '../../../../models/url/models/inboxesUrlModel';
import {AssignTabEducationTip} from './assignTabEducationTip';
import {
  SandboxEducationTipCoordinator,
  useDismissSandboxEducationTip,
} from './sandboxEducationTipCoordinator';

/*
 * Props.
 */

interface AssignTabEducationTipCoordinatorProps {
  conversationId: number | undefined;
  filter: InboxesFiltersEnum | InboxesSearchLocationsEnum;
  children?: ReactNode;
}

/*
 * Constants.
 */

const step = 'navigate-to-assigned-tab';

/*
 * Component.
 */

export const AssignTabEducationTipCoordinator: FC<AssignTabEducationTipCoordinatorProps> = (props) => {
  if (props.filter !== InboxesFiltersEnum.ASSIGNED) {
    return <>{props.children}</>;
  }

  return (
    <SandboxEducationTipCoordinator
      conversationId={props.conversationId}
      scenario={SandboxScenariosEnum.SCENARIO3_ACT1}
      step={step}
      isEligible
      EducationTip={AssignTabEducationTip}
      delay={1000}
    >
      {props.children}
    </SandboxEducationTipCoordinator>
  );
};

/*
 * Hook.
 */

export function useAssignTabEducationTip(conversationId: number | undefined) {
  const onDismiss = useDismissSandboxEducationTip<SandboxScenariosEnum.SCENARIO3_ACT1>(conversationId, step);

  const onFilterClick = useEventHandler((filter: InboxesFiltersEnum | InboxesSearchLocationsEnum): void => {
    if (filter !== InboxesFiltersEnum.ASSIGNED) {
      return;
    }

    onDismiss();
  });

  return {onFilterClick};
}
